export default "__VITE_ASSET__bbF4$YL1__"